module.exports = __webpack_public_path__ + "img/anno1800wallpaper@0,25x.077b92b2.jpg";